<template>
  <div class="animated fadeIn">
    <b-card>
      <remnant-past-apply
        ref="remnantPastApply"
        :email="$store.state.EMAIL"
      />
    </b-card>
    <b-card>
      <remnant-past-review
        ref="remnantPastReview"
        :email="$store.state.EMAIL"
        :no-review="true"
      />
    </b-card>
  </div>
</template>
<script>
import RemnantPastApply from './remnant/RemnantPastApply'
import RemnantPastReview from './remnant/RemnantPastReview'

export default {
  name: 'RemnantPastRecord',
  components: { RemnantPastApply, RemnantPastReview },
  data: function () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style>
</style>
